
import { COMPONENT_MAP } from '../../../utils/landingsData';
import scrollDepth from '../../../utils/ladingsMixins/scrollDepth';
import sectionReach from '../../../utils/ladingsMixins/sectionReach';

export default {
    name: 'MeatSinglePage',
    mixins: [scrollDepth, sectionReach],
    layout: 'MeatLayout',

    async asyncData({ app, params, error, env, query, $axios }) {
        const currentLocale = app.i18n.locale
        const { supplier, landing } = params
        const { preview } = query

        try {
            const meatResponse = await $axios.$get(`${env.API_URL_SITE}/landing/${landing}/${supplier}${preview ? `?preview=${preview}` : ""}`);

            return { pageData: meatResponse.data[currentLocale] };
        } catch (e) {
            console.error('Failed to fetch data:', e);
            return error({ statusCode: 404, message: 'Page not found' })
        }

    },

    head() {
        return {
            bodyAttrs: {
                class: 'meat-page-body'
            },
            script: [
                {
                    hid: 'yandex-metrika',
                    src: '/meat/lib/yandex-metrika.js',
                    type: 'text/javascript',
                    charset: 'utf-8'
                }
            ],
            noscript: [
                {
                    hid: 'yandex-metrika-noscript',
                    innerHTML: '<div><img src="https://mc.yandex.ru/watch/25259228" style="position:absolute; left:-9999px;" alt="" /></div>'
                }
            ],
            ...(this.pageData ? this.pageData.head : {})
        }
    },

    computed: {
        sortedBlocks() {
            if (!this.pageData || !this.pageData.blocks) return [];

            return Object.entries(this.pageData.blocks)
                .map(([key, blockData]) => ({
                    key,       
                    ...blockData 
                }))
                .sort((a, b) => (a.sort || 0) - (b.sort || 0));
        }
    },

    methods: {
        getComponent(key) {
            return COMPONENT_MAP[key] || null;
        }
    }
}
